import type {SweetAlertOptions} from "sweetalert2";
import 'vue3-toastify/dist/index.css';

const notifyOptions: any = {
  position: 'top-center',
  autoClose: 3000,
  theme: 'light',
};

const Alert = {
  _getSwal: async () => {
    const {default: Swal} = await import('sweetalert2');
    return Swal;
  },

  _getToast: async () => {
    const {toast} = await import('vue3-toastify');
    return toast;
  },

  fire: async (options: SweetAlertOptions): Promise<void> => {
    const Swal = await Alert._getSwal();
    Swal.fire(options);
  },

  info: async (message: string, title: string = '', options: SweetAlertOptions = {}): Promise<void> => {
    const opt = Object.assign({html: message, title, icon: 'info', confirmButtonText: 'OK'}, options);
    await Alert.fire(opt);
  },

  warn: async (message: string, title: string = '', options: SweetAlertOptions = {}): Promise<void> => {
    const opt = Object.assign({html: message, title, icon: 'warning', confirmButtonText: 'OK'}, options);
    await Alert.fire(opt);
  },

  error: async (message: string, title: string = '', options: SweetAlertOptions = {}): Promise<void> => {
    const opt = Object.assign({html: message, title, icon: 'error', confirmButtonText: 'OK'}, options);
    await Alert.fire(opt);
  },

  success: async (message: string, title: string = '', options: SweetAlertOptions = {}): Promise<void> => {
    const opt = Object.assign({html: message, title, icon: 'success', confirmButtonText: 'OK'}, options);
    await Alert.fire(opt);
  },

  confirm: async (message: string, title: string = "", options: SweetAlertOptions = {}): Promise<boolean> => {
    const Swal = await Alert._getSwal();
    const opt = Object.assign({
        html: message,
        title,
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Sim",
        denyButtonText: "Não"
      },
      options
    );
    const result = await Swal.fire(opt);
    return result.isConfirmed;
  },

  notifyInfo: async (text: string) => {
    const toast = await Alert._getToast();
    toast.info(text, notifyOptions);
  },

  notifyError: async (text: string) => {
    const toast = await Alert._getToast();
    toast.error(text, notifyOptions);
  },

  notifyWarning: async (text: string) => {
    const toast = await Alert._getToast();
    toast.warning(text, notifyOptions);
  },

  notifySuccess: async (text: string) => {
    const toast = await Alert._getToast();
    toast.success(text, notifyOptions);
  }
};

export default Alert;
